import { AiMcp } from "./AiMcp";

/** Settings › Your own AI (the polish round, 2026-10-31; DECISIONS "The polish round…"): the person's own AI connection, its own section under
 *  You instead of a tab of Settings › AI, in the padded page like Profile. Holders of `team` also find everyone's connections here. */
export function YourOwnAiSettings() {
  return (
    <>
      <div className="ob-page__head"><div><h1 className="ob-page__title">Your own AI</h1><p className="ob-page__subtitle">Connect your own AI app: it works your queue with your rights and uses no credits.</p></div></div>
      <div className="ob-form"><AiMcp /></div>
    </>
  );
}
